import type { ReceiptTemplate } from '../schema';

export const waveTemplate: ReceiptTemplate = {
  id: 'wave',
  name: 'Wave Receipt',
  brand: 'WAVE',
  description: 'Wave accounting receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'wv-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'WAVE',
        businessNameFontSize: 24,
        addressLines: ['PAYMENT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'wv-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'invoice', label: 'Invoice:', value: 'WV-847291034' },
          { id: 'business', label: 'From:', value: 'Acme Services' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'to', label: 'To:', value: 'John Doe' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'wv-desc',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'DESCRIPTION:\nConsulting Services - January 2026\nProject: Website Redesign', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'wv-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '1,500.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '0.00', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '1,500.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'wv-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'BANK TRANSFER', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'wv-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAID IN FULL\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: true },
    },
  ],
  updatedAt: new Date().toISOString(),
};

